import React from 'react';
import '../template-file-css/document-file-template.css';



export const LHH_TelephoneVisitationAgreement = ({
    itemsRef,
    showErrorFor,

}) => {

    return (
        <form id='LHH_TelephoneVisitationAgreement' className='file-pdf-document'>
            <div className='file-template'>

                <p className='w-750'><h3>Telephone/Visitation Agreement</h3></p>
                <p className='w-750'>
                    While receiving services from: &nbsp;
                    <input type='text' id='txtNumber1' name='txtNumber1' className='add-only w-250 custom-add-only' /> (Provider)
                </p>
                <p className='w-750'>
                    I give consent to receive phone calls and visits from those specific persons named in the sections
                    below and who are outside the program/facility for support and coordination of my treatment services.
                </p>
                <p className='w-750'>
                    <input type='checkbox' name='chkParticipation' id='chkParticipation' className='add-only' value='IAgreeParticipation' />
                        I agree to have my participation in this program acknowledged and accept telephone calls from any individuals.
                </p>
                <p className='w-750'>
                    <input type='checkbox' name='chkParticipation1' id='chkParticipation1' className='add-only' value='IAgreeHave' />
                        I agree to have my participation in this program acknowledged and accept telephone calls only from
                        the following named individuals:
                </p>
                <table>
                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>Name</span>
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>Telephone Number(s)</span>
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>Relationship</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='text' id='txtName' name='txtName' className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type='text' id='txtTelephone' name='txtTelephone' className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type='text' id='txtRelationship' name='txtRelationship' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='text' id='txtName1' name='txtName1' className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type='text' id='txtTelephone1' name='txtTelephone1' className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type='text' id='txtRelationship1' name='txtRelationship1' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='text' id='txtName2' name='txtName2' className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type='text' id='txtTelephone2' name='txtTelephone2' className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type='text' id='txtRelationship2' name='txtRelationship2' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='text' id='txtName3' name='txtName3' className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type='text' id='txtTelephone3' name='txtTelephone3' className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type='text' id='txtRelationship3' name='txtRelationship3' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='text' id='txtName4' name='txtName4' className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type='text' id='txtTelephone4' name='txtTelephone4' className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type='text' id='txtRelationship4' name='txtRelationship4' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='text' id='txtName5' name='txtName5' className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type='text' id='txtTelephone5' name='txtTelephone5' className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type='text' id='txtRelationship5' name='txtRelationship5' className='add-only' />
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <input type='checkbox' name='chkParticipation4' id='chkParticipation4' className='add-only' value='IParticipation1' />
                        I agree to accept and individual as a visitor.
                </p>
                <p className='w-750'>
                    <input type='checkbox' name='chkParticipation5' id='chkParticipation5' className='add-only' value='IParticipation2' />
                        I agree to accept as visitors the following named individuals only:
                </p>
                <table>
                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>Name</span>
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>Telephone Number(s)</span>
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>Relationship</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='text' id='txtName6' name='txtName6' className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type='text' id='txtTelephone6' name='txtTelephone6' className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type='text' id='txtRelationship6' name='txtRelationship6' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='text' id='txtName7' name='txtName7' className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type='text' id='txtTelephone7' name='txtTelephone7' className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type='text' id='txtRelationship7' name='txtRelationship7' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='text' id='txtName8' name='txtName8' className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type='text' id='txtTelephone8' name='txtTelephone8' className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type='text' id='txtRelationship8' name='txtRelationship8' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='text' id='txtName9' name='txtName9' className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type='text' id='txtTelephone9' name='txtTelephone9' className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type='text' id='txtRelationship9' name='txtRelationship9' className='add-only' />
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <input type='checkbox' id='cbConsent_1' name='cbConsent_1' className='add-only' value='Consent1' />
                    I understand this consent will expire upon my discharge from the program. I may revoke this consent at any time
                    except to the extent that action has already taken place.
                </p>
                <p className='w-750'>
                    <input type='checkbox' id='cbConsent_2' name='cbConsent_2' className='add-only' value='Consent2' />
                    I understand that interns and delivery/maintenance people enter the premises on occasion and I will not hold
                    the service provider staff responsible for any visitors that may disclose my presence in this program.
                </p>


            </div>
        </form >

    )
}











